// UserProfilePage.tsx

import React from 'react';
import { useAuth } from '../../context/AuthContext'; // Path adjust karein
import { useNavigate, useLocation } from 'react-router-dom';
import UserOrdersPage from './OrdersPage'; // Ensure this file is saved as OrdersPage.tsx




// --- Helper Content Components (Defined for the content area) ---

// 1. Profile Content
const ProfileContent: React.FC<{ userName: string }> = ({ userName }) => (
    <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2">My Profile Details</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
                <p className="text-sm font-medium text-gray-500">Name</p>
                <input 
                    type="text" 
                    defaultValue={userName} 
                    placeholder="Enter your name"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-yellow-500 focus:border-yellow-500 transition duration-200"
                />
            </div>
            
            <div className="space-y-4">
                <p className="text-sm font-medium text-gray-500">Email ID</p>
                 <input 
                    type="email" 
                    defaultValue="user.email@example.com"
                    readOnly
                    className="w-full p-3 border border-gray-300 bg-gray-50 rounded-lg text-gray-600"
                />
            </div>

            <div className="space-y-4">
                <p className="text-sm font-medium text-gray-500">Mobile No.</p>
                 <input 
                    type="tel" 
                    defaultValue="9876543210"
                    placeholder="Enter mobile number"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-yellow-500 focus:border-yellow-500 transition duration-200"
                />
            </div>
            
        </div>

        <button 
            className="mt-8 px-6 py-3 bg-yellow-600 text-white font-semibold rounded-lg shadow-md hover:bg-yellow-700 transition duration-300"
        >
            Update Profile
        </button>
    </div>
);

// 2. Generic Placeholder Content
const PlaceholderContent: React.FC<{ title: string }> = ({ title }) => (
    <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">{title}</h3>
        <p className="text-gray-600">This is the content area for the **{title}** section. The full functionality will be implemented here.</p>
        <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded">
            <p className="text-yellow-800">Currently displaying placeholder content.</p>
        </div>
    </div>
);


// --- Main UserProfilePage Component ---
const UserProfilePage: React.FC = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    
    // Security check: If not logged in, redirect to login page
    if (!user) {
        navigate('/login'); 
        return null;
    }

    const userName = user.userName || 'User';
    const currentPath = location.pathname;
    
    // Function to load the correct content component
    const renderContent = () => {
        // Check current URL path to determine which content to display
        if (currentPath.startsWith('/orders')) {
            return <UserOrdersPage />;
        }
        if (currentPath.startsWith('/wishlist')) {
            return <PlaceholderContent title="My Wishlist" />;
        }
        // if (currentPath.startsWith('/profile/address-book')) {
        //     return <PlaceholderContent title="Address Book" />;
        // }
        if (currentPath.startsWith('/wallet')) {
            return <PlaceholderContent title="My Wallet" />;
        }
        
        // Default: /profile route
        return <ProfileContent userName={userName} />;
    };
    
    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-3xl font-bold text-gray-900 mb-8">My Account</h1>
                
                <div className="flex flex-col lg:flex-row gap-8">
                    
                  
                    
                    {/* --- Content Area (DYNAMIC) --- */}
                    <div className="lg:w-3/4 w-full">
                        {renderContent()} {/* Only this content changes */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfilePage;